import { DEPARTMENT_ENDPOINT } from '../endpoints/'
import getRequest from '../request/getRequest'

export default async () => {
  try {
    const response = await getRequest({
      url: `${DEPARTMENT_ENDPOINT}`
    })
    const { data } = response.data
    const status = response.status
    return { status, response: data }
  } catch (error) {
    const { Error } = error.response.data
    const status = error.response.status
    return { status, response: Error }
  }
}
